// Compliance Call Checking: the routes and the sidebar rows of `wealth.ai.compliance-call-checking` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.ai.compliance-call-checking',
    routes: [
        {
            frontend: 'comply',
            path: 'call-intelligence',
            lazy: () => import('@/pages/comply/call-intelligence/page'),
        },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'atlas-intelligence',
            label: 'ATLAS Intelligence',
            href: '/comply/call-intelligence',
            icon: 'BrainCircuit',
            group: 'monitoring',
            order: 430,
            wip: true,
        },
    ],
});
